
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationSwitchViewMine: {
    id: "ConfigurationSwitchView.mine",
    defaultMessage: "My Configurations",
  }, 
  configurationSwitchViewOthers: {
    id: "ConfigurationSwitchView.connected",
    defaultMessage: "Connected",
  }, 
  configurationSwitchViewArchived: {
    id: "ConfigurationSwitchView.archived",
    defaultMessage: "Archived",
  }
});

export default MESSAGES;